import styled from '@emotion/styled';

export const GateViewport = styled('main')(({ theme }) => ({
  minHeight: '100dvh',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box',
  padding: theme.spacing[24],
  backgroundColor: theme.colors.background.canvas,
}));

export const GatePanel = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing[16],
  padding: theme.spacing[24],
  boxSizing: 'border-box',
  border: `1px solid ${theme.colors.error.border}`,
  borderRadius: theme.radius[12],
  backgroundColor: theme.colors.error.subtle,
  boxShadow: theme.shadows.sm,
  textAlign: 'center',
}));

export const GateCopy = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[8],
  textWrap: 'pretty',
}));
